import { render, staticRenderFns } from "./BbppRanking.vue?vue&type=template&id=4e339049"
import script from "./BbppRanking.vue?vue&type=script&lang=js"
export * from "./BbppRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports